import { Component, ViewEncapsulation, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { RequestComponent } from './components/features/request/request';
import { RequestService } from './services/request';
import { DialogService } from './services/shared/dialog.service';
import { MCDialogComponent } from '@maslul/common-components';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RequestComponent,
    MCDialogComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'MyImport';
  langDirection = 'mc-rtl-lang';

  private translateService = inject(TranslateService);
  private requestService = inject(RequestService);
  dialogService = inject(DialogService);

  constructor() {
    this.translate();
    this.requestService.initMyImportFormState();
  }

  translate() {
    const langTranslate = 'he';
    this.translateService.use(langTranslate);
  }
}
